const StoreIcon = () => {
	return (
		<svg
			width="17"
			height="18"
			viewBox="0 0 17 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1.66284 8.20312V10.6031C1.66284 13.6201 1.66284 15.1286 2.6001 16.0659C3.53736 17.0031 5.04585 17.0031 8.06284 17.0031H8.86284C11.8798 17.0031 13.3883 17.0031 14.3256 16.0659C15.2628 15.1286 15.2628 13.6201 15.2628 10.6031V8.20312"
				stroke="#A2A2A2"
			/>
			<path
				d="M6.46268 1H10.4627L10.9841 6.21389C11.1332 7.7056 9.96183 9 8.46268 9C6.96353 9 5.79212 7.7056 5.94129 6.2139L6.46268 1Z"
				stroke="#A2A2A2"
			/>
			<path
				d="M1.52669 3.68106C1.66916 2.96874 1.74039 2.61259 1.88522 2.32387C2.1904 1.71551 2.73952 1.26534 3.39591 1.0854C3.70743 1 4.07064 1 4.79706 1H6.46291L5.88328 6.79622C5.75818 8.04728 4.70543 9 3.44813 9C1.90377 9 0.745483 7.58711 1.04836 6.07275L1.52669 3.68106Z"
				stroke="#A2A2A2"
			/>
			<path
				d="M15.3991 3.68106C15.2566 2.96874 15.1854 2.61259 15.0406 2.32387C14.7354 1.71551 14.1863 1.26534 13.5299 1.0854C13.2184 1 12.8552 1 12.1287 1H10.4629L11.0425 6.79622C11.1676 8.04728 12.2204 9 13.4777 9C15.022 9 16.1803 7.58711 15.8774 6.07275L15.3991 3.68106Z"
				stroke="#A2A2A2"
			/>
			<path
				d="M6.46289 16.6031V14.2031C6.46289 13.4554 6.46289 13.0816 6.62366 12.8031C6.72898 12.6207 6.88047 12.4692 7.06289 12.3639C7.34135 12.2031 7.7152 12.2031 8.46289 12.2031C9.21058 12.2031 9.58443 12.2031 9.86289 12.3639C10.0453 12.4692 10.1968 12.6207 10.3021 12.8031C10.4629 13.0816 10.4629 13.4554 10.4629 14.2031V16.6031"
				stroke="#A2A2A2"
				strokeLinecap="round"
			/>
		</svg>
	);
};

export default StoreIcon;
